import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import GeneralCountryComponent from "./GeneralCountryComponent";
import ItalyComoIntroSection from "../../components/tours/italy/como/ItalyComoIntroSection";
import ItalyComoTripInformationSection from "../../components/tours/italy/como/ItalyComoTripInformationSection";
import ItalyComoImagesSection from "../../components/tours/italy/como/ItalyComoImagesSection";
import ItalyComoTripDetailsSection from "../../components/tours/italy/como/ItalyComoTripDetailsSection";


const ItalyComo = () => {
    return (
        <GeneralCountryComponent title={'italy_como'}>
            <ItalyComoIntroSection/>
            <ItalyComoTripInformationSection/>
            <ItalyComoImagesSection/>
            <ItalyComoTripDetailsSection/>
        </GeneralCountryComponent>
    );
}

export default ItalyComo;
